// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Vlz3","subheader":"ReorderModal_subheader__3QXR-","listWrap":"ReorderModal_listWrap__Vd19U"};